import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dados',
  templateUrl: './dados.component.html',
  styleUrls: ['./dados.component.scss'],
  standalone: false
})
export class DadosComponent implements OnInit {

  @Input() dados: any;
  @Input() tipo: string;
  @Input() tipoCurso: number;

  constructor() { }

  ngOnInit(): void {}

}
